module.exports = __webpack_public_path__ + "static/media/forgot-password-vector.5efd9674.svg";